import * as React from "react";
import { Checkbox as PrimeCheckbox } from "primereact/checkbox";
import type { FormEvent } from "primereact/ts-helpers";
import { cn } from "@/lib/utils";

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  onCheckedChange?: (checked: boolean) => void;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
    const [internalChecked, setInternalChecked] = React.useState(checked ?? false);

    const isControlled = checked !== undefined;
    const currentChecked = isControlled ? checked : internalChecked;

    const handleChange = (e: FormEvent<boolean>) => {
      const checked = e.checked ?? false;
      if (!isControlled) {
        setInternalChecked(checked);
      }
      onCheckedChange?.(checked);
    };

    return (
      <PrimeCheckbox
        inputRef={ref}
        checked={currentChecked}
        onChange={handleChange}
        disabled={disabled}
        className={cn(className)}
        {...props}
      />
    );
  }
);
Checkbox.displayName = "Checkbox";

export { Checkbox };
